import React from "react";
import { Helmet } from "_c/Helmet";
import { generateUrl } from "@/utils/cloudinary";
import { SITE_URL } from "@/misc/constants";
import qs from "query-string";

const SEO = ({ article }) => {
  const canonical = qs.stringifyUrl({
    url: `${SITE_URL}/blog/article/${article.slug}`,
  });
  return (
    <Helmet
      title={article.title}
      link={[
        { rel: "canonical", href: canonical },
        {
          rel: "preload",
          href: "/images/about-head.png",
          as: "image",
        },
      ]}
      meta={[
        {
          name: "description",
          content: article.desc,
        },
        {
          property: "og:image",
          content: article.thumb && generateUrl(article.thumb),
        },
        {
          name: "keywords",
          content: (article.tags || []).join(", "),
        },
      ]}
    >
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org/",
          "@type": "BlogPosting",
          "@id": article.slug,
          headline: article.title,
          author: [article.author.first_name, article.author.last_name]
            .filter(Boolean)
            .join(" "),
          datePublished: article.created_at,
          dateModified: article.updated_at,
          image: article.thumb ? generateUrl(article.thumb) : "",
          description: article.desc,
          articleBody: article.content,
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
